import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { api_url } from "../../constant/constant";

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const getInitialLanguage = () => {
    const storedLang = localStorage.getItem("lng") || "en"; 
    return {
      lang: storedLang,
      flag:
        storedLang === "ar"
          ? "/images/icons8-saudi-arabia.svg"
          : "/images/icons8-us-flag.svg",
    };
  };

  const [selectedLanguage, setSelectedLanguage] = useState(getInitialLanguage());

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage.lang);
    const dir = selectedLanguage.lang === "ar" ? "rtl" : "ltr";
    document.documentElement.dir = dir;
    document.body.setAttribute("dir", dir);
  }, [selectedLanguage.lang, i18n]);

  const handleLanguageChange = async (lang, flag) => {
    const updatedLang = await changeUserLanguage(lang); 
    if (updatedLang) {
      setSelectedLanguage({
        lang: updatedLang.language_code,
        flag:
          updatedLang.language_code === "ar"
            ? "/images/icons8-saudi-arabia.svg"
            : "/images/icons8-us-flag.svg",
      });
      localStorage.setItem("lng", updatedLang.language_code);
    } else {
      // agar API fail ho jaye to fallback
      setSelectedLanguage({ lang, flag });
      localStorage.setItem("lng", lang);
    }
    const currentPath = window.location.pathname;
    if (
      !currentPath.includes("/QuizNormal") && 
      !currentPath.includes("/CampaignExam")
    ) {
      window.location.reload();
    }
  };

  const changeUserLanguage = async (lng) => {
    const language_id = lng === "en" ? 1 : 2;
    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(api_url + "/settings/language/auth", {
        mode: "cors",
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, 
        },
        body: JSON.stringify({ language_id }),
      });

      const result = await response.json();
      console.log("Language Update Response:", result);

      if (result.status === "success") {
        console.log(result.message);
        return result.data; // ✅ return API ka data
      } else {
        console.log("Error:", result.message);
        return null;
      }
    } catch (err) {
      console.error("Language update failed:", err.message);
      return null;
    }
  };

  return (
    <div className="dropdown nav-item me-2">
      <a
        className="nav-link dropdown-toggle d-flex align-items-center"
        href="#"
        id="submenu"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <img
          src={selectedLanguage.flag}
          width="24"
          alt="Language"
          className="me-2"
        />
      </a>
      <ul className="dropdown-menu" aria-labelledby="submenu">
        <li>
          <a
            href="#"
            className="dropdown-item"
            onClick={() =>
              handleLanguageChange("en", "/images/icons8-us-flag.svg")
            }
          >
            <img
              src="/images/icons8-us-flag.svg"
              width="24"
              alt="English"
              className="me-2"
            />
            {t("English")}
          </a>
        </li>
        <li>
          <a
            href="#"
            className="dropdown-item"
            onClick={() =>
              handleLanguageChange("ar", "/images/icons8-saudi-arabia.svg")
            }
          >
            <img
              src="/images/icons8-saudi-arabia.svg"
              width="24"
              alt="العربية"
              className="me-2"
            />
            العربية
          </a>
        </li>
      </ul>
    </div>
  );
};

export default LanguageSwitcher;
